import React, { useState } from 'react';
import { FiltersCheckbox } from '../../FiltersCheckbox/FiltersCheckbox';
import type { ListMultiSelectCheckboxProps } from './ListMultiSelectCheckbox.typed';
import * as Styled from './ListMultiSelectCheckbox.styled';

// Number of options required to trigger displaying the "Show all" button
const OPTIONS_TO_ENABLE_SHOW_MORE = 6;
// Number of options to show if we have OPTIONS_TO_ENABLE_SHOW_MORE options or more.
const OPTIONS_TO_SHOW = 4;

const ListMultiSelectCheckbox = (props: ListMultiSelectCheckboxProps) => {
  const {
    options,
    onSelectOption,
    selectedOptions,
    showMoreLabel,
    defaultShouldShowMore = true,
  } = props;
  const [showAll, setShowAll] = useState(defaultShouldShowMore);

  const shouldShowMore = options.length >= OPTIONS_TO_ENABLE_SHOW_MORE;
  const displayedOptions =
    shouldShowMore && !showAll ? options.slice(0, OPTIONS_TO_SHOW) : options;

  const pluralLabel = `${showMoreLabel}${
    showMoreLabel?.charAt(showMoreLabel.length - 1) !== 's' ? 's' : ''
  }`.toLowerCase();

  return (
    <>
      {displayedOptions.map((option) => {
        const { label, value, count } = option;
        const isSelected = !!selectedOptions?.find(
          (selectedOption) => selectedOption === value,
        );

        return (
          <FiltersCheckbox
            key={`option-${value}`}
            label={label}
            value={value}
            count={count}
            isSelected={isSelected}
            onSelectOption={() => onSelectOption(value, !isSelected)}
          />
        );
      })}
      {shouldShowMore && !showAll && (
        <Styled.ShowMoreButton
          onClick={() => setShowAll(!showAll)}
          fontSize="M16"
          fontWeight="regular"
        >
          {!showAll && `Show all ${pluralLabel}`}
        </Styled.ShowMoreButton>
      )}
    </>
  );
};

export { ListMultiSelectCheckbox };
